import React, {useEffect} from 'react';
import {RiseInterstitialProps} from 'screens/InsomniaSurvey/components/RiseInterstitialTemplate/RiseInterstitialBase';
import {surveyInstance} from 'screens/InsomniaSurvey/InsomniaSurvey';
import InsuranceCoveredInterstitial from '../InsuranceCoveredInterstitial/InsuranceCoveredInterstitial';
import InsuranceNotCoveredInterstitial from '../InsuranceNotCoveredInterstitial/InsuranceNotCoveredInterstitial';

const SleepioPausedValidationInterstitial: React.FC = () => {
  useEffect(() => {
    surveyInstance.setValue('insurance_is_valid', 'no');
    surveyInstance.setValue('clinic_booking_paused', true);
    const timer = window.setTimeout(() => {
      surveyInstance.nextPage();
    }, 50);
    return () => window.clearTimeout(timer);
  }, []);

  return null;
};

type InsuranceValidationInterstitialProps = RiseInterstitialProps & {
  /**
   * True on the `/book-appointment` funnel, where clinic appointments are bookable:
   * show the covered / not-covered result so the booking pages can follow.
   *
   * False (default) on the `/start` SleepioRx funnel, where booking is paused: skip
   * the result silently and let the SleepioRx branch decide what to show.
   */
  bookingEnabled?: boolean;
};

/**
 * Shows appropriate interstitial based on insurance coverage validation
 * The validation is performed in the previous page's onNext handler
 */
const InsuranceValidationInterstitial: React.FC<InsuranceValidationInterstitialProps> = ({bookingEnabled = false}) => {
  if (!bookingEnabled) {
    return <SleepioPausedValidationInterstitial />;
  }

  // Read the insurance_is_valid value that was set in the previous page's onNext handler
  const insuranceIsValid = surveyInstance.getValue('insurance_is_valid');

  // Show appropriate interstitial based on validation result
  return insuranceIsValid === 'yes' ? (
    <InsuranceCoveredInterstitial />
  ) : (
    <InsuranceNotCoveredInterstitial variant="coverage" />
  );
};

export default InsuranceValidationInterstitial;
